import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", "/dashboard");
        setUser(data.user);
        navigate(data.user.onboarded ? "/dashboard" : "/onboarding", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return <div className="min-h-screen flex items-center justify-center text-slate-400">Signing you in…</div>;
}
